import { computed } from 'vue';
import { useProductFlags } from '@modules/featureControl';
import { useProduct } from '@modules/product';

/**
 * @param {Product} [product]
 * @returns {product is MemberProduct}
 */
function isMemberProduct(product) {
  if (!product) {
    return false;
  }

  const { isMemberProduct: flag } = useProductFlags();
  return flag;
}

/**
 * @returns {{
 *  masterProductUrl: import('vue').ComputedRef<string>,
 *  membersOfMasterCount: import('vue').ComputedRef<number>,
 *  orderedSiblingProductIds: import('vue').ComputedRef<number>
 * }}
 */
export function useMemberProduct() {
  const { productData: product } = useProduct();
  if (isMemberProduct(product)) {
    const masterProductUrl = computed(() => product?.relationships?.masterProduct?.identifier?.productUrl);
    const membersOfMasterCount = computed(() => product?.relationships?.masterProduct.detail.memberProductCount);
    const orderedSiblingProductIds = computed(() => product?.relationships?.orderedSiblingProductIds?.length);

    return {
      masterProductUrl,
      membersOfMasterCount,
      orderedSiblingProductIds,
    };
  }
  return {
    masterProductUrl: computed(() => ''),
    membersOfMasterCount: computed(() => 0),
    orderedSiblingProductIds: computed(() => 0),
  };
}

export default useMemberProduct;
